import { persist } from 'zustand/middleware';

import { troubleshootingHoldOption } from '@constants/troubleshootingHoldOption';

import { createStore } from '@store/createStore';

export const filterInitialState = {
  maxTimeCreated: undefined,
  minTimeCreated: undefined,
  urgency: 'all',
  type: 'all',
  metricType: 'days',
  reportedFailure: false,
  facilityIds: [],
  states: [0, 2, 3, 5, 6, 7, 9, 10, troubleshootingHoldOption.id],
};

const useSiteEngagementMetricsFilterStorePersist = createStore(
  persist(
    (set) => ({
      ...filterInitialState,
      actions: {
        setSiteEngagementMetricsFilterInitialState: () => set({ ...filterInitialState }),
        setSiteEngagementMetricsFilterState: (filter) => set({ ...filter }),
      },
    }),
    {
      version: 1,
      name: 'site-engagement-metrics-filters',
      partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => key !== 'actions')),
    },
  ),
  'SiteEngagementMetricsFilterStorePersist',
);

export const useSiteEngagementMetricsFilterStorePersistActions = () =>
  useSiteEngagementMetricsFilterStorePersist((state) => state.actions);

export const selectSiteEngagementMetricsFilterStorePersistState = () =>
  useSiteEngagementMetricsFilterStorePersist((state) => ({
    maxTimeCreated: state.maxTimeCreated,
    minTimeCreated: state.minTimeCreated,
    urgency: state.urgency,
    type: state.type,
    reportedFailure: state.reportedFailure,
    metricType: state.metricType,
    facilityIds: state.facilityIds,
    states: state.states,
  }));
